import { render, staticRenderFns } from "./MultiMoveShops.vue?vue&type=template&id=7445434e&scoped=true"
import script from "./MultiMoveShops.vue?vue&type=script&lang=ts"
export * from "./MultiMoveShops.vue?vue&type=script&lang=ts"
import style0 from "./MultiMoveShops.vue?vue&type=style&index=0&id=7445434e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445434e",
  null
  
)

export default component.exports